export default __webpack_public_path__ + "static/media/Ash Mantle of the Living Legend.d7b80cbd.jpg";